module.exports = __webpack_public_path__ + "static/media/pattern--cow.600ee4ea.svg";